import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import ReferenceRewardPopup from "./ReferenceRewardPopup";
import ReferenceInviteBonusPopup from "./ReferenceInviteBonusPopup";
import ReferenceAnnounce from "./ReferenceAnnounce";
import ReferenceMessageToast from "./ReferenceMessageToast";

const ENTRY_REWARDS_KEY = "chorki-show-rewards";
let entryPopupStarted = false;

export function resetEntryPopupForTests() {
  entryPopupStarted = false;
}

const SIDE_LINKS = [
  {
    key: "cs",
    label: "CUSTOMER SERVICE",
    href: "#",
    icon: "cs",
  },
  {
    key: "fb",
    label: "FACEBOOK",
    href: "https://www.facebook.com/",
    icon: "fb",
  },
  {
    key: "tg",
    label: "TELEGRAM",
    href: "https://t.me/",
    icon: "tg",
  },
  {
    key: "tgcs",
    label: "TELEGRAM CS",
    href: "https://t.me/",
    icon: "tg",
  },
];

const PROMOTION_AUTOPLAY_MS = 3000;
const PROMOTION_SPEED_MS = 1000;

const PROMOTIONS = [
  { key: "login", image: "/assets/bdtwin/promo-ui-LOGIN.webp", label: "Login reward", action: "rewards" },
  { key: "mission", image: "/assets/bdtwin/promo-ui-MISSION.ccf240f3.gif", label: "Mission", action: "/member?tab=mission" },
  { key: "promocode", image: "/assets/bdtwin/promo-ui-PromoCode.png", label: "Promo code", action: "/promotions" },
  { key: "temu", image: "/assets/bdtwin/promo-ui-TEMU.gif", label: "Lucky draw", action: "/promotions" },
  { key: "wheel", image: "/assets/bdtwin/promo-ui-PRIZE_WHEEL.17d37f44.gif", label: "Prize wheel", action: "rewards" },
  { key: "event", image: "/assets/bdtwin/promo-vendor-sort.webp", label: "Event", action: "/promotions", vendor: true },
  { key: "featured", image: "/assets/bdtwin/promo-vendor-event.png", label: "Featured games", action: "/casino/hot", vendor: true },
];

function OpenPromotionIcon() {
  return (
    <svg viewBox="0 0 34 34" aria-hidden="true">
      <defs>
        <radialGradient id="ref-open-promotion-fill" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(180 13.142 15.818) scale(32.6771)">
          <stop stopColor="#FF9D00" />
          <stop offset="1" stopColor="#FF3800" />
        </radialGradient>
      </defs>
      <path d="M17 0C7.611 0 0 7.611 0 17s7.611 17 17 17 17-7.611 17-17S26.389 0 17 0Z" fill="url(#ref-open-promotion-fill)" />
      <path d="m16.09 12.893.91-.91.91.91 4.85 4.85c.172.172.4.266.644.266a.896.896 0 0 0 .84-.562.896.896 0 0 0-.197-.992l-6.114-6.115a1.32 1.32 0 0 0-1.866 0l-6.115 6.115a.896.896 0 0 0-.197.992.897.897 0 0 0 .841.562.905.905 0 0 0 .644-.266l2.425-2.425 2.425-2.425Z" fill="#fff" />
      <path d="m16.09 18.143.91-.91.91.91 4.85 4.85c.172.171.4.266.644.266a.896.896 0 0 0 .84-.562.896.896 0 0 0-.197-.992l-6.114-6.115a1.32 1.32 0 0 0-1.866 0l-6.115 6.115a.896.896 0 0 0-.197.992.897.897 0 0 0 .841.562.905.905 0 0 0 .644-.266l2.425-2.425 2.425-2.425Z" fill="#fff" />
    </svg>
  );
}

function SideIcon({ type }) {
  if (type === "fb") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M14 8h2.5V5.5C16.1 5.2 15 5 13.7 5 11.2 5 9.5 6.5 9.5 9.2V11H7v3h2.5v7H13v-7h2.3l.5-3H13V9.4c0-.9.3-1.4 1-1.4Z"
        />
      </svg>
    );
  }
  if (type === "tg") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M20.6 4.3 3.8 10.7c-1.1.4-1.1 1.1-.2 1.4l4.3 1.3 1.7 5.1c.2.6 0 .8.5.8.3 0 .5-.1.7-.4l2.5-2.5 5.2 3.8c1 .5 1.7.2 1.9-.9l2.7-12.7c.3-1.1-.4-1.6-1.2-1.3Zm-9.7 10.2-.2-3.5 8.9-5.6c.4-.2.7-.1.4.2l-9.1 8.9Z"
        />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 2a7 7 0 0 0-7 7v3.2A3.8 3.8 0 0 0 3 15.8V17a2 2 0 0 0 2 2h1.2A2.8 2.8 0 0 0 9 21.8h6A2.8 2.8 0 0 0 17.8 19H19a2 2 0 0 0 2-2v-1.2a3.8 3.8 0 0 0-2-3.6V9a7 7 0 0 0-7-7Zm-5 9a5 5 0 0 1 10 0v2.1l.4.2A1.8 1.8 0 0 1 19 14.8V17h-1.2A2.8 2.8 0 0 0 15 14.2H9A2.8 2.8 0 0 0 6.2 17H5v-2.2a1.8 1.8 0 0 1 1.6-1.7l.4-.2V11Z"
      />
    </svg>
  );
}

export default function DesktopFloating() {
  const [showPromotions, setShowPromotions] = useState(true);
  const [promotionIndex, setPromotionIndex] = useState(0);
  const [promotionsExpanded, setPromotionsExpanded] = useState(false);
  const [trackAnimated, setTrackAnimated] = useState(true);
  const [listEdges, setListEdges] = useState({ top: true, bottom: false });
  const promotionListRef = useRef(null);
  const navigate = useNavigate();
  const [sideOpen, setSideOpen] = useState(false);
  const [rewardsOpen, setRewardsOpen] = useState(false);
  const [rewardTab, setRewardTab] = useState(0);
  const [inviteOpen, setInviteOpen] = useState(false);
  const [announceOpen, setAnnounceOpen] = useState(false);
  const [flowActive, setFlowActive] = useState(false);
  const sideRef = useRef(null);
  const swipeStart = useRef(null);
  const suppressPromotionClick = useRef(false);
  const lastWheel = useRef(0);
  const loginFlowStarted = useRef(false);
  const guestFlowStarted = useRef(false);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const loggedIn = Boolean(user?.user || user?.username);

  const startLoginFlow = () => {
    setInviteOpen(true);
    setAnnounceOpen(false);
    setRewardTab(0);
    setFlowActive(true);
    setRewardsOpen(true);
  };

  useEffect(() => {
    let cancelled = false;
    const id = window.setTimeout(() => {
      if (cancelled) return;
      const authed = loggedIn || Boolean(localStorage.getItem("token"));
      const justLoggedIn = sessionStorage.getItem(ENTRY_REWARDS_KEY) === "1";
      if (justLoggedIn && authed) {
        sessionStorage.removeItem(ENTRY_REWARDS_KEY);
        entryPopupStarted = true;
        loginFlowStarted.current = true;
        startLoginFlow();
        return;
      }
      if (entryPopupStarted) return;
      entryPopupStarted = true;
      if (authed) {
        loginFlowStarted.current = true;
        startLoginFlow();
        return;
      }
      guestFlowStarted.current = true;
    }, 0);
    return () => {
      cancelled = true;
      window.clearTimeout(id);
    };
  }, [loggedIn]);

  useEffect(() => {
    const openAnnounce = () => {
      setFlowActive(false);
      setRewardsOpen(false);
      setInviteOpen(false);
      setAnnounceOpen(true);
    };
    window.addEventListener("chorki-open-announce", openAnnounce);
    return () => window.removeEventListener("chorki-open-announce", openAnnounce);
  }, []);

  useEffect(() => {
    if (!sideOpen) return undefined;
    const onPointer = (event) => {
      if (!sideRef.current?.contains(event.target)) setSideOpen(false);
    };
    const onKey = (event) => {
      if (event.key === "Escape") setSideOpen(false);
    };
    document.addEventListener("mousedown", onPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [sideOpen]);

  const closeRewards = (reason, visibleTab = rewardTab) => {
    setRewardsOpen(false);
    if (reason === "deposit" || reason === "betting") {
      setFlowActive(false);
      setInviteOpen(false);
      setAnnounceOpen(false);
      return;
    }
    if (!flowActive) return;
    if (visibleTab === 0) {
      setRewardTab(1);
      setRewardsOpen(true);
      return;
    }
    setFlowActive(false);
  };

  const closeInvite = (reason) => {
    if (reason === "leave") setAnnounceOpen(false);
    setInviteOpen(false);
    setFlowActive(false);
  };

  const promotionCount = PROMOTIONS.length;
  const activePromotion = ((promotionIndex % promotionCount) + promotionCount) % promotionCount;

  const movePromotion = (direction) => {
    setTrackAnimated(true);
    setPromotionIndex((index) => Math.min(Math.max(index + direction, -1), promotionCount));
  };

  useEffect(() => {
    if (!showPromotions || promotionsExpanded) return undefined;
    const id = window.setInterval(() => movePromotion(1), PROMOTION_AUTOPLAY_MS);
    return () => window.clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPromotions, promotionsExpanded]);

  useEffect(() => {
    if (promotionIndex >= 0 && promotionIndex < promotionCount) return undefined;
    const id = window.setTimeout(() => {
      setTrackAnimated(false);
      setPromotionIndex(promotionIndex < 0 ? promotionCount - 1 : 0);
    }, PROMOTION_SPEED_MS);
    return () => window.clearTimeout(id);
  }, [promotionIndex, promotionCount]);

  const scrollPromotionList = (direction) => {
    promotionListRef.current?.scrollBy({ top: direction * 125, behavior: "smooth" });
  };

  const updateListArrows = () => {
    const list = promotionListRef.current;
    if (!list) return;
    setListEdges({
      top: list.scrollTop <= 2,
      bottom: list.scrollTop + list.clientHeight >= list.scrollHeight - 2,
    });
  };

  useEffect(() => {
    if (promotionsExpanded) updateListArrows();
  }, [promotionsExpanded]);

  const openPromotion = (item) => {
    if (suppressPromotionClick.current) return;
    if (item.action === "rewards") {
      setFlowActive(false);
      setInviteOpen(false);
      setAnnounceOpen(false);
      setRewardTab(item.key === "wheel" ? 1 : 0);
      setRewardsOpen(true);
      return;
    }
    navigate(item.action);
  };

  const renderPromotion = (item) =>
    item.vendor ? (
      <span className="ref-promo-vendor">
        <img src={item.image} alt="" draggable="false" />
        <i className="ref-promo-unread" aria-hidden="true" />
      </span>
    ) : (
      <span className="ref-promo-gif" style={{ backgroundImage: `url(${item.image})` }} />
    );

  const trackSlides = [PROMOTIONS[promotionCount - 1], ...PROMOTIONS, PROMOTIONS[0]];

  return (
    <aside className="ref-floating-controls" aria-label="Quick links">
      <div ref={sideRef} className={`ref-side-menu${sideOpen ? " open" : ""}`}>
        <button
          type="button"
          className="ref-support-orb"
          aria-label="CHORKI quick links"
          aria-expanded={sideOpen ? "true" : "false"}
          onClick={() => setSideOpen((value) => !value)}
        >
          <img className="ref-support-orb-logo" src="/assets/chorki/logo.svg" alt="" aria-hidden="true" />
        </button>
        {SIDE_LINKS.map((item, index) => (
          <a
            key={item.key}
            className={`ref-side-menu-item menu_item_${index}`}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={sideOpen ? 0 : -1}
            aria-hidden={sideOpen ? "false" : "true"}
          >
            <span className="ref-side-menu-inner">
              <SideIcon type={item.icon} />
              <span>{item.label}</span>
            </span>
          </a>
        ))}
      </div>

      {showPromotions && (
        <div className={`ref-promo-float${promotionsExpanded ? " expanded" : ""}`}>
          <button
            type="button"
            className="ref-promo-close"
            aria-label="Hide promotions"
            onClick={() => setShowPromotions(false)}
          />
          <button
            type="button"
            className="ref-promo-open"
            aria-label={promotionsExpanded ? "Collapse promotions" : "Show all promotions"}
            aria-expanded={promotionsExpanded ? "true" : "false"}
            onClick={() => setPromotionsExpanded((value) => !value)}
          >
            <OpenPromotionIcon />
          </button>
          {promotionsExpanded ? (
            <div className="ref-promo-list-wrap">
              {!listEdges.top && (
                <button
                  type="button"
                  className="ref-promo-arrow prev"
                  aria-label="Previous promotions"
                  onClick={() => scrollPromotionList(-1)}
                />
              )}
              <div
                ref={promotionListRef}
                className="ref-promo-list"
                aria-label="Promotions"
                onScroll={updateListArrows}
              >
                {PROMOTIONS.map((item, index) => (
                  <button
                    key={item.key}
                    type="button"
                    className={`ref-promo-slide${index === activePromotion ? " active" : ""}`}
                    aria-label={item.label}
                    onClick={() => {
                      setTrackAnimated(false);
                      setPromotionIndex(index);
                      openPromotion(item);
                    }}
                  >
                    {renderPromotion(item)}
                  </button>
                ))}
              </div>
              {!listEdges.bottom && (
                <button
                  type="button"
                  className="ref-promo-arrow next"
                  aria-label="More promotions"
                  onClick={() => scrollPromotionList(1)}
                />
              )}
            </div>
          ) : (
            <div
              className="ref-promo-swiper"
              aria-roledescription="carousel"
              aria-label="Promotions"
              onPointerDown={(event) => {
                swipeStart.current = { x: event.clientX, id: event.pointerId };
                event.currentTarget.setPointerCapture?.(event.pointerId);
              }}
              onPointerUp={(event) => {
                if (!swipeStart.current) return;
                const delta = event.clientX - swipeStart.current.x;
                if (Math.abs(delta) > 24) {
                  suppressPromotionClick.current = true;
                  movePromotion(delta < 0 ? 1 : -1);
                  window.setTimeout(() => {
                    suppressPromotionClick.current = false;
                  }, 0);
                }
                swipeStart.current = null;
              }}
              onWheel={(event) => {
                const now = Date.now();
                const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
                if (now - lastWheel.current < 600 || Math.abs(delta) < 8) return;
                lastWheel.current = now;
                movePromotion(delta > 0 ? 1 : -1);
              }}
            >
              <div
                className="ref-promo-track"
                style={{
                  transform: `translateX(-${(promotionIndex + 1) * 130}px)`,
                  transition: trackAnimated ? `transform ${PROMOTION_SPEED_MS}ms ease` : "none",
                }}
              >
                {trackSlides.map((item, index) => {
                  const current = index === promotionIndex + 1;
                  return (
                    <button
                      key={`${item.key}-${index}`}
                      type="button"
                      className={`ref-promo-slide${current ? " active" : ""}`}
                      aria-label={item.label}
                      aria-hidden={current ? "false" : "true"}
                      tabIndex={current ? 0 : -1}
                      onClick={() => openPromotion(item)}
                    >
                      {renderPromotion(item)}
                    </button>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      )}
      <ReferenceMessageToast />
      {rewardsOpen && <ReferenceRewardPopup key={rewardTab} initialTab={rewardTab} onClose={closeRewards} />}
      {inviteOpen && <ReferenceInviteBonusPopup covered={rewardsOpen} initialStep="progress" onClose={closeInvite} />}
      {announceOpen && <ReferenceAnnounce covered={rewardsOpen || inviteOpen} onClose={() => setAnnounceOpen(false)} />}
    </aside>
  );
}
